"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FieldTypes = void 0;
var component_fields_1 = require("@doordash/component-fields");
var Autocomplete_1 = __importDefault(require("./FormFields/Autocomplete/Autocomplete"));
var Checkbox_1 = require("./FormFields/Checkbox");
var DateTime_1 = __importDefault(require("./FormFields/DateTime"));
var EntityRelationshipInput_1 = __importDefault(require("./FormFields/EntityRelationshipInput"));
var FileInput_1 = require("./FormFields/FileInput");
var ReadOnlyLink_1 = require("./FormFields/ReadOnlyLink");
var TextArea_1 = require("./FormFields/TextArea");
exports.FieldTypes = {
    // DLS Text Fields:
    DateField: component_fields_1.DateField,
    EmailField: component_fields_1.EmailField,
    IdentificationField: component_fields_1.IdentificationField,
    NumberField: component_fields_1.NumberField,
    PasswordField: component_fields_1.PasswordField,
    PhoneField: component_fields_1.PhoneField,
    SearchField: component_fields_1.SearchField,
    Select: component_fields_1.Select,
    TextField: component_fields_1.TextField,
    TimeField: component_fields_1.TimeField,
    // Custom FormField components:
    Autocomplete: Autocomplete_1["default"],
    Checkbox: Checkbox_1.Checkbox,
    DateTime: DateTime_1["default"],
    EntityRelationshipInput: EntityRelationshipInput_1["default"],
    FileInput: FileInput_1.FileInput,
    ReadOnlyLink: ReadOnlyLink_1.ReadOnlyLink,
    TextArea: TextArea_1.TextArea
};
